<div class="modal active">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2>Import User Layer</h2>
      <div class="close" (click)="bsModalRef.hide()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  name="ngUserLayerForm" #ngForm="ngForm" id="ngUserLayerForm" class="active" >
          <div class="fields__block">
            <div class="fields__block__section">
              <p>Please enter a name for the layer:</p>
              <div class="input-fields">
                  <input type="text" [(ngModel)]="layerName" name="layerName" required>
              </div>
            </div>
            <div class="fields__btn">
              <button [ngClass]="ngForm.valid ? 'blue' : 'gray'" (click)="drawOnMap();bsModalRef.hide()" [disabled]="!ngForm.valid">
                Submit
              </button>
              <button class="gray" (click)="bsModalRef.hide()">
                Cancel
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

